export const BASE_URL = "https://electromart-e-com-backend.onrender.com";
